import React from 'react';

import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ReceiptIcon from '@mui/icons-material/Receipt';

export const ExpenseCategoryIcons = {
  Transport: <LocalTaxiIcon />,
  Meal: <RestaurantIcon />,
  Accommodation: <ApartmentIcon />,
  Other: <ReceiptIcon />,
} as const;
